<script setup>
/* eslint semi: 1 */
defineProps({
  currentPage: {
    type: Number,
    default: 1,
  },
  totalPages: {
    type: Number,
    default: 1,
  },
  minItemsCount: {
    type: Number,
    default: 0
  },
  maxItemsCount: {
    type: Number,
    default: 0
  },
  totalItemsCount: {
    type: Number,
    default: 0
  },
  isPreviousDisabled: {
    type: Boolean,
    default: false,
  },
  isNextDisabled: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['page-select']);
</script>

<template>
  <div class="w-full flex justify-end">
    <Paginator
      pagination-type="manual"
      :current-page="currentPage"
      :total-pages="totalPages"
      :min-items-count="minItemsCount"
      :max-items-count="maxItemsCount"
      :total-items-count="totalItemsCount"
      :is-previous-disabled="isPreviousDisabled"
      :is-next-disabled="isNextDisabled"
      @page-select="$emit('page-select', $event)"
    />
  </div>
</template>
